import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CanonicalTag = () => {
  const location = useLocation();

  useEffect(() => {
    const canonical = document.querySelector('link[rel="canonical"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const robotsMeta = document.querySelector('meta[name="robots"]');

    // Pages that should consolidate into the homepage listing
    const consolidateToHome = ['/swimming-pool-construction', '/about'];
    const shouldConsolidate = consolidateToHome.includes(location.pathname);

    const canonicalUrl = shouldConsolidate
      ? 'https://www.aquaristpools.com/'
      : `https://www.aquaristpools.com${location.pathname === '/' ? '/' : location.pathname}`;

    if (canonical) canonical.setAttribute('href', canonicalUrl);
    if (ogUrl) ogUrl.setAttribute('content', canonicalUrl);

    // Set noindex on pages being consolidated to suppress duplicate listings
    if (robotsMeta) {
      robotsMeta.setAttribute('content', shouldConsolidate ? 'noindex, follow' : 'index, follow');
    }
  }, [location.pathname]);

  return null;
};

export default CanonicalTag;
